import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from "@nuxtjs/composition-api";
import { productDetailLink } from "@/utils/product";
import { ProductTypes } from "@/constants/productType";
import ProductLevelIcon from "~/components/ProductLevelIcon.vue";

import { toThousandFilter } from "~/utils/filters";

export declare interface ProductCollectItem {
  product_no: string;
  name: string;
  image: string;
  min_sale_price: number;
  currency_label: string;
  is_tripartite_product: string;
  min_th_price: number;
  product_date: string;
  level_pic: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Product-collection-item',
  props: {
    info: null
  },
  setup(__props: any) {

const props = __props as {
  info: ProductCollectItem;
}


const productUrl = computed(() => {
  if (props.info.is_tripartite_product === "1") {
    //单船票产品
    return `/product/automation/${props.info.product_no}`;
  } else {
    return productDetailLink(ProductTypes.CRUISE, props.info.product_no);
  }
});
const navigateToDetail = function () {
  window.open(productUrl.value, "_blank");
};
const { $auth } = useContext();
const isDistributor = computed(() => {
  if (!$auth.loggedIn) return false;
  return !!$auth.user!.distributor;
});

return { __sfc: true,props, productUrl, navigateToDetail, $auth, isDistributor, ProductLevelIcon, toThousandFilter }
}

})